import Http from '../http'

export const index = (page, name) => Http.get(`/bank-accounts?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/bank-accounts', { data }, { headers: { Authorization: localStorage.token } })
export const show = (id) => Http.get(`/bank-accounts/${id}`, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/bank-accounts/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/bank-accounts/${id}`, { headers: { Authorization: localStorage.token } })
